// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"154":"8152d659","516":"a1821478","653":"0bd3d1e3"}[chunkId] + ".css";
};